window.globalHelpersModule.directive "confirmedProposalRejected", 
['$rootScope', '$log', '$timeout', '$filter', '$state', 'AuthService', 'toastr',
($rootScope, $log, $timeout, $filter, $state, AuthService, toastr) ->
  restrict: "E"
  scope:
    feedItem: "="
  link: (scope, element, attrs) ->

  templateUrl: 'portal/appointments/feed-items/confirmed_proposal_rejected/confirmed_proposal_rejected-directive-template.html'
]